<!--
 * @Author: qin 15936669602@163.com
 * @Date: 2025-06-28 16:03:03
 * @LastEditors: qin 15936669602@163.com
 * @LastEditTime: 2025-08-23 14:55:20
 * @FilePath: /360-house-viewing-main/src/components/ChapterCard.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="chapter-card">
    <router-link
      :to="{ name: 'SkyBox', query: { id: chapter.code } }"
      class="chapter-link"
    >
      <!-- 封面区 -->
      <div class="cover-img">
        <img
          v-if="!imageError && chapter.imgUrl"
          :src="baseUrl + chapter.imgUrl"
          alt="章节封面"
          class="cover-photo"
          @error="handleImgError"
        />
        <!-- 高级占位封面 -->
        <div v-else class="cover-placeholder">
          <div class="cp-icon-wrap">
            <i class="el-icon-video-camera"></i>
          </div>
          <span class="cp-label">情景章节</span>
          <div class="cp-grid"></div>
        </div>

        <!-- 渐变遮罩 -->
        <div class="cover-mask"></div>

        <!-- 左下角章节标签 -->
        <span class="cover-badge">进入情景</span>

        <!-- hover 顶部光条 -->
        <div class="cover-glow-bar"></div>
      </div>

      <!-- 内容区 -->
      <div class="chapter-content">
        <div class="chapter-title">{{ chapter.title || '未命名章节' }}</div>
        <div class="chapter-desc">{{ chapter.description || '点击进入该情景章节，开始学习训练。' }}</div>
        <div class="chapter-action">
          <span>进入学习</span>
          <i class="el-icon-right"></i>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ChapterCard",
  data() {
    return {
      imageError: false,
    };
  },
  props: {
    chapter: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(["baseUrl"]),
  },
  methods: {
    handleImgError() {
      this.imageError = true;
    },
  },
};
</script>

<style scoped>
/* ─────────────────────────────────────────
   Card shell
───────────────────────────────────────── */
.chapter-card {
  height: 100%;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(168, 199, 245, 0.70);
  border-radius: 18px;
  box-shadow: 0 8px 24px rgba(8, 28, 66, 0.07);
  transition: transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease;
}

.chapter-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 44px rgba(8, 28, 66, 0.12);
  border-color: rgba(30, 155, 255, 0.36);
}

.chapter-link {
  display: block;
  text-decoration: none;
  color: inherit;
  height: 100%;
}

/* ─────────────────────────────────────────
   Cover
───────────────────────────────────────── */
.cover-img {
  position: relative;
  height: 186px;
  background: linear-gradient(135deg, #e8f0fc, #f4f8ff);
  overflow: hidden;
}

.cover-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.36s ease;
}

.chapter-card:hover .cover-photo {
  transform: scale(1.05);
}

/* Premium placeholder */
.cover-placeholder {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;
  overflow: hidden;
}

.cp-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(21, 87, 216, 0.09) 1px, transparent 1px),
    linear-gradient(90deg, rgba(21, 87, 216, 0.09) 1px, transparent 1px);
  background-size: 20px 20px;
  pointer-events: none;
}

.cp-icon-wrap {
  position: relative;
  z-index: 1;
  width: 50px;
  height: 50px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, rgba(21, 87, 216, 0.12), rgba(32, 200, 255, 0.16));
  border: 1px solid rgba(21, 87, 216, 0.16);
  color: #1557d8;
  font-size: 22px;
  box-shadow: 0 8px 20px rgba(21, 87, 216, 0.13);
}

.cp-label {
  position: relative;
  z-index: 1;
  font-size: 12px;
  font-weight: 800;
  color: #1557d8;
  letter-spacing: 0.5px;
}

/* Gradient mask */
.cover-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 48%, rgba(8, 20, 52, 0.30));
  pointer-events: none;
}

/* Bottom-left badge */
.cover-badge {
  position: absolute;
  z-index: 2;
  left: 11px;
  bottom: 11px;
  padding: 3px 8px;
  border-radius: 999px;
  color: #fff;
  background: rgba(18, 72, 200, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(8px);
  font-size: 10px;
  font-weight: 800;
}

/* Top glow bar on hover */
.cover-glow-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  z-index: 4;
  background: linear-gradient(90deg, #1248c8, #20c8ff, rgba(32, 200, 255, 0));
  opacity: 0;
  transition: opacity 0.24s ease;
}

.chapter-card:hover .cover-glow-bar {
  opacity: 1;
}

/* ─────────────────────────────────────────
   Content
───────────────────────────────────────── */
.chapter-content {
  padding: 14px 15px 12px;
}

.chapter-title {
  height: 44px;
  margin: 0 0 7px;
  overflow: hidden;
  color: #081c42;
  font-size: 15px;
  line-height: 1.46;
  font-weight: 900;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.chapter-desc {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #475569;
  font-size: 12px;
  line-height: 1.72;
  min-height: 40px;
}

.chapter-action {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(226, 232, 240, 0.8);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #1557d8;
  font-size: 12px;
  font-weight: 900;
  transition: color 0.2s;
}

.chapter-card:hover .chapter-action {
  color: #1e9bff;
}
</style>
